import axios from 'axios';

const fetchCategoryContent = async (categoryId, setPreview) => {
  let category = await axios.get(`/markisen-konfigurator/category/?categoryId=${categoryId}&pluginSetPreview=${setPreview}`);
  category = category.data.category.details[0];

  if (!category) {
    return {};
  }

  return {
    modalContent: category.description,
    title: category.shortDescription,
    cardContent: category.description2,
  };
};

const fetchImages = ({ commit, state }, setPreview) => {
  state.options.forEach((option) => {
    axios
      .get(`/markisen-konfigurator/images/?variationId=${option.id}&pluginSetPreview=${setPreview}`)
      .then((response) => {
        option.images = response.data.images;
        commit('setOption', option);
      });
  });
}

const setOption = (state, option) => {
  state.options = state.options.map(existingOption => {
    if (existingOption.id !== option.id) return existingOption;
    return option;
  })
}

export { fetchCategoryContent, fetchImages, setOption };
